import { FC } from 'react'
import clsx from 'clsx'

import { TypeCodes, MaterialTypes } from 'constants/data'
import { MaterialsColor, MaterialsType } from './constants'

import styles from './card-category.module.scss'
import commonStyles from 'styles/common/cards.module.scss'

interface ICardCategory {
  materialType?: MaterialTypes
  ArticleTypeId?: number
}

const defineMaterialType = (materialType?: MaterialTypes, ArticleTypeId?: number) => {
  if (materialType === MaterialTypes.FUTURE_WEBINAR) return MaterialsType.WEBINAR
  if (materialType === MaterialTypes.WEBINAR) return MaterialsType.WEBINAR_PAST
  if (materialType === MaterialTypes.PODCAST) return MaterialsType.PODCAST
  if (ArticleTypeId === TypeCodes.VIDEO) return MaterialsType.VIDEO
  if (ArticleTypeId === TypeCodes.ARTICLE) return MaterialsType.ARTICLE
  if (ArticleTypeId === TypeCodes.CLINIC) return MaterialsType.CLINIC
  if (ArticleTypeId === TypeCodes.CLINIC_CASE) return MaterialsType.CLINIC_CASE
  return ''
}

const CardCategory: FC<ICardCategory> = ({ materialType, ArticleTypeId }: ICardCategory) => {
  const category = defineMaterialType(materialType, ArticleTypeId)
  const colorStyle = styles[MaterialsColor[category]]

  return (
    <div id="plashka-article" className={clsx(commonStyles.plashka, styles.plashka, colorStyle)}>
      {category}
    </div>
  )
}

export default CardCategory
